export const quickHierarchy = {
  namespaced: true,
  persistent: ["activeTab"],
  state: {
    activeTab: undefined,
  },
  getters: {
    activeTab: (state) => state.activeTab,
  },
  mutations: {
    activeTab: (state, value) => (state.activeTab = value),
  },
  actions: {
    activeTab: ({ commit }, value) => commit("activeTab", value),
  },
};
